exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " /* .loader-overlay {\r\n   bottom: 0;\r\n   left: 0;\r\n   position: fixed;\r\n   right: 0;\r\n   top: 0;\r\n } */\r\n\r\n .overlay {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  position: fixed;\r\n  z-index: 1001;\r\n  /* Sit on top */\r\n  left: 0;\r\n  top: 0;\r\n  background-color: rgb(0, 0, 0);\r\n  /* Black fallback color */\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  /* Black w/opacity */\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/loader/loader.component.css
// module id = ../../../../../src/app/loader/loader.component.css
// module chunks = 0